import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Container } from '@mui/joy';

import { WindscreenManagement } from '../components/Windscreen';
import BreadcrumbLayout from '../components/layout/BreadcrumbLayout';
import ResponsiveLayout from '../components/layout/ResponsiveLayout';
import { BreadcrumbItem } from '../models/BreadcrumbItem';

const WindscreenManagementPage: React.FC = () => {
  const { t } = useTranslation();
  
  const [breadcrumbItems] = useState<BreadcrumbItem[]>([
    { text: t('navigation.admin_tools'), link: '/dashboard' },
    { text: t('navigation.windscreen_management') }
  ]);

  return (
    <ResponsiveLayout>
      <BreadcrumbLayout breadcrumbItems={breadcrumbItems}>
        <Container>
          <Box sx={{ mb: 4 }}>
            <WindscreenManagement />
          </Box>
        </Container>
      </BreadcrumbLayout>
    </ResponsiveLayout>
  );
};

export default WindscreenManagementPage;
